// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__BEwKl","short":"Loader_short__WWiAt","loader":"Loader_loader__lqUPL"};